import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ToastrService } from "ngx-toastr";
import { HttpService } from "@app/core/services";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { DesignService, DesignKind } from "@app/core/services/design.service";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-photo-report-replacer-gallery",

  templateUrl: "./photo-report-replacer.component.html",
  styleUrls: ["./photo-report-replacer.component.scss"],
})
export class PhotoReportReplacerComponent implements OnInit, OnDestroy {
  public imgSrc;
  public images: File[] = [];
  public design: DesignKind = "classic";
  @Output() photoChange: EventEmitter<File[]> = new EventEmitter<File[]>();
  private ngUnsubscribe = new Subject();

  constructor(
    private sanitizer: DomSanitizer,
    private toastr: ToastrService,
    private translateService: TranslateService,
    private httpService: HttpService,
    private ref: ChangeDetectorRef,
    private designService: DesignService
  ) {
    this.design = this.designService.getDesign();
    this.designService.design$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((d) => {
        this.design = d;
      });
  }

  @Input() set photos(value) {
    this.images = this.images.concat(value);
    let self = this;
    setTimeout(() => {
      self.ref.detectChanges();
    }, 500);
    // console.log("onSelect", this.images);
    self.ref.detectChanges();
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  cli() {
    const blob = new Blob(this.images);
    this.imgSrc = this.sanitizer.bypassSecurityTrustUrl(
      URL.createObjectURL(blob)
    );
  }

  onSelect(event) {
    this.images = this.images.concat(event.addedFiles);
    let self = this;
    setTimeout(() => {
      self.ref.detectChanges();
    }, 500);
    // console.log("onSelect", this.images);
    self.ref.detectChanges();
  }

  onRemove(event) {
    this.images.splice(this.images.indexOf(event), 1);
  }

  replacePhoto(): void {
    this.photoChange.emit(this.images);

    // console.log("replacePhoto", this.images);
  }
}
